const Checkmark = ({ width = 12, height = 12 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.50443 3.87012H7.8763C7.73969
        3.87012 7.60978 3.93574 7.52942 4.04824L5.42407
        6.96789L4.4705 5.64467C4.39014 5.53351 4.26157
        5.46655 4.12362 5.46655H3.4955C3.40844 5.46655 
        3.35755 5.56565 3.40844 5.63664L5.07719 
        7.95092C5.11661 8.00594 5.16858 8.05078 5.22879 
        8.08171C5.289 8.11263 5.35571 8.12877 5.4234 8.12877C5.49109
        8.12877 5.5578 8.11263 5.61801 8.08171C5.67821 8.05078
        5.73018 8.00594 5.7696 7.95092L8.59014 4.04021C8.64237 
        3.96922 8.59148 3.87012 8.50443 3.87012Z"
    />
    <path
      d="M6 0C2.68661 0 0 2.68661 0 6C0 9.31339
        2.68661 12 6 12C9.31339 12 12 9.31339 12 6C12
        2.68661 9.31339 0 6 0ZM6 10.9821C3.24911 10.9821
        1.01786 8.75089 1.01786 6C1.01786 3.24911 3.24911
        1.01786 6 1.01786C8.75089 1.01786 10.9821 3.24911 
        10.9821 6C10.9821 8.75089 8.75089 10.9821 6 10.9821Z"
    />
  </svg>
);
export default Checkmark;
